import { httpClient } from '@/services/http/httpClient'

type PortfolioUser = {
  id: string
  name: string
  email: string
  image: string | null
  type: string
  status?: string
}

type Tag = {
  id: string
  name: string
  textColor: string
  color: string
}

export type GetPortfolioIdResponse = {
  id: string
  title: string
  description: string
  tennantId: string
  ownerId: string
  createdAt: string
  updatedAt: string
  portfolioUsers: PortfolioUser[]
  tags: Tag[]
  countProjects: number
  totalUsers: number
}

export async function getPortfolioId(id: string) {
  const { data } = await httpClient.get<GetPortfolioIdResponse>(
    `/projects/portfolios/${id}`,
  )

  return data
}
